import { TextBox } from "devextreme-react";
import { useAtom } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import { EmailRule, PatternRule, RequiredRule, Validator } from "devextreme-react/validator";
import CommonButton from "@components/common/button";
import React, { useState } from "react";
import { baseZIndex } from "devextreme/ui/overlay";
import { CommonConst } from "@constants/common-const";
import { getCompanyCustomerSearch, getCustomerSearch } from "@service/user/customer-user-service";
import PopUpSearch from "@components/popup-search";
import { RegExpConst } from "@constants/regexp";
import useCounselHook from "@feature/counsel/useCounselHook";

type Props = {
  accessType: string;
};

const CounselCustomerInfo = ({ accessType }: Props) => {
  const [hCostResult, setHCostResult] = useAtom(hcostInboundAtom);
  const [customerPopupVisible, setCustomerPopupVisible] = useState(false);
  const { onValueChangeCounselHandler } = useCounselHook();

  const _getCustomerSearch = async (searchData: string) => {
    try {
      if (accessType === CommonConst.ACCESS_TYPE_ADMIN) {
        const { data } = await getCompanyCustomerSearch(hCostResult.company.id, `search=${searchData}`);

        return data;
      } else {
        const { data } = await getCustomerSearch(`search=${searchData}`);
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const setCustomer = (data: Customer) => {
    setHCostResult(prev => ({
      ...prev,
      customerName: data.name,
      customerPhone: data.mobileNumber,
      customerEmail: data.email,
    }));
  };

  baseZIndex(40);

  return (
    <>
      {/*고객 정보*/}
      <div className="content-fieldset">
        <h3 className="content-fieldset-title flex justify-between">
          고객 정보
          {accessType === CommonConst.ACCESS_TYPE_ADMIN && (
            <CommonButton color="white" className="w-20 h-[34px]" onClick={() => setCustomerPopupVisible(true)}>
              검색
            </CommonButton>
          )}
        </h3>
        <div className="content-fieldset-title-desc" />
        {customerPopupVisible && (
          <PopUpSearch
            fetchData={_getCustomerSearch}
            setData={setCustomer}
            isVisible={customerPopupVisible}
            handleClose={setCustomerPopupVisible}
          />
        )}

        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name required">고객명</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <TextBox
              value={hCostResult.customerName}
              maxLength="10"
              placeholder="고객명"
              showClearButton
              onValueChanged={onValueChangeCounselHandler((draft, value) => {
                draft.customerName = value;
              })}
            >
              <Validator>
                <RequiredRule />
              </Validator>
            </TextBox>
            <div className="content-value-desc" />
          </div>
        </div>

        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name required">연락처</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <TextBox
              maxLength="30"
              value={hCostResult.customerPhone}
              placeholder="010-0000-0000"
              valueChangeEvent="keyup"
              showClearButton
              onValueChanged={onValueChangeCounselHandler((draft, value) => {
                draft.customerPhone = value;
              })}
            >
              <Validator>
                <RequiredRule />
                <PatternRule
                  message="형식이 올바르지 않습니다. '-'기호 포함 하여 입력해주세요"
                  pattern={RegExpConst.PATTERN_PHONE_NUM}
                />
              </Validator>
            </TextBox>
            <div className="content-value-desc" />
          </div>
        </div>

        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name">이메일</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <TextBox
              maxLength="30"
              value={hCostResult.customerEmail}
              placeholder="이메일"
              showClearButton
              valueChangeEvent="keyup"
              onValueChanged={onValueChangeCounselHandler((draft, value) => {
                draft.customerEmail = value;
              })}
            >
              <Validator>
                <EmailRule message="이메일 주소가 유효하지 않습니다." />
              </Validator>
            </TextBox>
            <div className="content-value-desc" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CounselCustomerInfo;
